import { useEffect, useMemo } from 'react';
import { ShopGridProducts } from '~/components/ui/ShopGridProducts';
import {
	ShopItemProduct,
	ShopItemProductVariant,
} from '~/components/ui/ShopItemProduct';
import { rage, useObservable } from '~/rage';
import {
	setActiveIndex,
	setActiveItem,
	setCount,
	setMaxIndex,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { getCategoriesFromItems } from '../../views/ProductShop/ProductShop.model';

const ProductList = () => {
	const dispatch = useLayoutDispatch();
	const activeIndex = useLayoutSelector(
		(state) => state.productShop.activeIndex,
	);
	const activeTab = useLayoutSelector((state) => state.productShop.activeTab);
	const items = useObservable(rage.productShop.getItems());
	const categories = getCategoriesFromItems(items);

	const filteredCategories = useMemo(() => {
		return categories.filter((category) => {
			return items.some((item) => item.category === category.id);
		});
	}, [categories, items]);

	const filteredItems = useMemo(() => {
		if (activeTab === 0) {
			return items;
		}
		const category = filteredCategories[activeTab - 1];
		return items.filter((item) => item.category === category?.id);
	}, [items, activeTab, filteredCategories]);

	const handleSetActive = (index: number) => {
		dispatch(setActiveIndex(index));
		dispatch(setActiveItem(filteredItems[index]));
	};

	useEffect(() => {
		if (filteredItems.length === 0) {
			dispatch(setActiveIndex(null));
			dispatch(setActiveItem(null));
		} else if (activeIndex === null) {
			dispatch(setActiveIndex(0));
			dispatch(setActiveItem(filteredItems[0]));
		} else if (activeIndex >= filteredItems.length) {
			const lastIndex = filteredItems.length - 1;
			dispatch(setActiveIndex(lastIndex));
			dispatch(setActiveItem(filteredItems[lastIndex]));
		}
	}, [filteredItems, activeIndex, dispatch]);

	useEffect(() => {
		if (
			activeIndex !== null &&
			activeIndex >= 0 &&
			activeIndex < filteredItems.length
		) {
			dispatch(setActiveItem(filteredItems[activeIndex]));
		}
	}, [activeIndex, filteredItems, dispatch]);

	useEffect(() => {
		if (activeIndex || activeIndex === 0) {
			const itemDiv = document.getElementById(`product-${activeIndex}`);
			if (itemDiv !== null) {
				setTimeout(() => {
					itemDiv.scrollIntoView({ block: 'nearest' });
				}, 50);
			}
		}
	}, [activeIndex]);

	useEffect(() => {
		dispatch(setCount(0));
	}, [activeIndex]);

	useEffect(() => {
		dispatch(setMaxIndex(filteredItems.length));
	}, [filteredItems]);

	return (
		<ShopGridProducts
			activeIndex={activeIndex}
			maxIndex={filteredItems.length}
			handleSelect={() => {}}
			handleSetActive={handleSetActive}
			style={{ gridAutoRows: 247 }}
		>
			{filteredItems.map((product, index) => (
				<ShopItemProduct
					itemId={product.id}
					collection="items"
					name={product.name}
					price={product.price}
					walletType={product.walletType}
					variant={ShopItemProductVariant.Large}
					priceLabel="Стоимость:"
					id={`product-${index}`}
					key={index}
					selected={activeIndex === index}
					onClick={() => handleSetActive(index)}
					trackerKey={`product-${product.category}.${product.id}`}
					trackerIsUnseen={(key) => rage.productShop.isUnseen(key)}
					trackerMarkSeen={(key) => rage.productShop.markSeen(key)}
				/>
			))}
		</ShopGridProducts>
	);
};

export { ProductList };
